import script from "./ConfirmDeleteDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmDeleteDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmDeleteDialog.vue?vue&type=style&index=0&id=2c8cc785&scoped=true&lang=css"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8cc785"]])

export default __exports__